<main>
  <div class="container-fluid">
    <h1 class="mt-4 mb-3">Merchant List</h1>

    <!-- Filters + actions in one row -->
    <div class="row g-2 mb-3 align-items-center">
      <div class="col">
        <input name="find" type="text" class="form-control" placeholder="Search id, name, email, VPS…"
               [(ngModel)]="query.queryString" (ngModelChange)="queryMerchants()">
      </div>
      <div class="col-auto" style="min-width:200px">
        <ng-select [items]="merchantGroups"
                   bindValue="id"
                   bindLabel="name"
                   placeholder="All Groups"
                   [clearable]="true"
                   [(ngModel)]="query.merchantGroupId"
                   (ngModelChange)="queryMerchants()">
        </ng-select>
      </div>
      <div class="col-auto" style="min-width:160px">
        <ng-select [items]="merchantTypes"
                   bindValue="id"
                   bindLabel="name"
                   placeholder="All Types"
                   [clearable]="true"
                   [(ngModel)]="query.merchantType"
                   (ngModelChange)="queryMerchants()">
        </ng-select>
      </div>
      <div class="col-auto">
        <div class="form-check mb-0">
          <input class="form-check-input" type="checkbox" id="includeDeleted"
                 [(ngModel)]="query.includeDeleted" (ngModelChange)="queryMerchants()">
          <label class="form-check-label" for="includeDeleted">Include Deleted</label>
        </div>
      </div>
      <div class="col-auto ml-auto d-flex" style="gap:6px">
        <app-tiktok-app-info></app-tiktok-app-info>
        <app-get-tiktok-api-category-id></app-get-tiktok-api-category-id>
        <app-sync-order-sheet *ngIf="this.userData.roles.indexOf('Team Leader') > -1
          || this.userData.roles.indexOf('Admin') > -1
          || this.userData.roles.indexOf('SuperAdmin') > -1">
        </app-sync-order-sheet>
        <button class="btn btn-primary" (click)="openMerchantModal('')">+ New Account</button>
      </div>
    </div>

    <!-- Table -->
    <div class="table-responsive">
      <table class="table table-bordered table-hover table-sm mb-0">
        <thead class="thead-light">
          <tr>
            <th class="sortable" (click)="sortBy('merchantId')">ID <i class="fas {{sortIcon('merchantId')}}"></i></th>
            <th class="sortable" (click)="sortBy('name')">Name <i class="fas {{sortIcon('name')}}"></i></th>
            <th class="sortable" (click)="sortBy('group')">Group <i class="fas {{sortIcon('group')}}"></i></th>
            <th class="sortable" (click)="sortBy('mainEmail')">Email <i class="fas {{sortIcon('mainEmail')}}"></i></th>
            <th class="sortable text-right" (click)="sortBy('availableBalance')">Balance <i class="fas {{sortIcon('availableBalance')}}"></i></th>
            <th class="sortable text-right" (click)="sortBy('holdBalance')">Hold <i class="fas {{sortIcon('holdBalance')}}"></i></th>
            <th class="sortable" (click)="sortBy('vpsName')">VPS <i class="fas {{sortIcon('vpsName')}}"></i></th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let m of queryResult.items" [class.table-danger]="m.isDeleted">
            <td class="text-monospace small">{{m.merchantId}}</td>
            <td>{{m.name}}</td>
            <td><span class="badge badge-secondary">{{m.merchantGroup?.name}}</span></td>
            <td class="small">{{m.mainEmail}}</td>
            <td class="text-right text-nowrap">
              <span *ngIf="m.availableBalance">{{m.availableBalance | number:'1.2-2'}} <small class="text-muted">{{m.balanceCurrency}}</small></span>
              <span *ngIf="!m.availableBalance" class="text-muted">—</span>
            </td>
            <td class="text-right text-nowrap">
              <span *ngIf="m.holdBalance" class="text-warning">{{m.holdBalance | number:'1.2-2'}} <small class="text-muted">{{m.balanceCurrency}}</small></span>
              <span *ngIf="!m.holdBalance" class="text-muted">—</span>
            </td>
            <td class="small">{{m.vpsName}}</td>
            <td>
              <div class="d-flex align-items-center" style="gap:4px">
                <button class="btn btn-sm btn-outline-secondary" (click)="openSetupTiktokModal(m.merchantId)" title="TikTok Setup">
                  <i class="fab fa-tiktok"></i>
                </button>
                <app-tiktok-push-product-config [merchant]="m"></app-tiktok-push-product-config>
                <app-setup-tiktok-flash-sale [merchant]="m"></app-setup-tiktok-flash-sale>
                <app-delete-product-modal [merchant]="m"
                  *ngIf="this.userData.roles.indexOf('Team Leader') > -1
                    || this.userData.roles.indexOf('Admin') > -1
                    || this.userData.roles.indexOf('SuperAdmin') > -1
                    || this.userData.roles.indexOf('Seller') > -1
                    || this.userData.roles.indexOf('Support') > -1">
                </app-delete-product-modal>
                <button class="btn btn-sm btn-outline-primary" (click)="openMerchantModal(m.merchantId)" title="Edit">
                  <i class="fas fa-pen-square"></i>
                </button>
                <button class="btn btn-sm btn-outline-danger" (click)="deleteMerchant(m)"
                  *ngIf="this.userData.roles.indexOf('Team Leader') > -1
                    || this.userData.roles.indexOf('Admin') > -1
                    || this.userData.roles.indexOf('SuperAdmin') > -1"
                  title="Delete">
                  <i class="fas fa-trash"></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="d-flex justify-content-end mt-2">
      <app-pagination [(pageNumber)]="query.pageNumber" [pageSize]="query.pageSize" [totalItems]="queryResult.total"
                      (onPageChanged)="queryMerchants($event)">
      </app-pagination>
    </div>
  </div>

  <ng-template #merchantModal let-modal>
    <div class="modal-header">
      <h4 class="modal-title">
        <span *ngIf="merchantDetail.merchantId">Edit</span>
        <span *ngIf="!merchantDetail.merchantId">Create New</span>
      </h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <form name="merchantDetail">
        <div class="form-group row">
          <label class="col-2 col-form-label">Merchant ID</label>
          <div class="col-10">
            <input type="text" class="form-control" [(ngModel)]="merchantDetail.merchantId" name="merchantId">
          </div>
        </div>
        <div class="form-group row">
          <label class="col-2 col-form-label">Name</label>
          <div class="col-10">
            <input type="text" class="form-control" [(ngModel)]="merchantDetail.name" name="merchantName">
          </div>
        </div>
        <div class="form-group row">
          <label class="col-2 col-form-label">Merchant Type</label>
          <div class="col-10">
            <ng-select [items]="merchantTypes" bindValue="id" bindLabel="name" [closeOnSelect]="true"
                       name="merchantType" [(ngModel)]="merchantDetail.merchantType">
            </ng-select>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-2 col-form-label">Group</label>
          <div class="col-10">
            <ng-select [items]="merchantGroups" bindValue="id" bindLabel="name" [closeOnSelect]="true"
                       name="merchantGroup" [(ngModel)]="merchantDetail.merchantGroupId">
            </ng-select>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-2 col-form-label">Main Email</label>
          <div class="col-10">
            <input type="text" class="form-control" [(ngModel)]="merchantDetail.mainEmail" name="mainEmail">
          </div>
        </div>
        <div class="form-group row">
          <label class="col-2 col-form-label">Auto Client Email</label>
          <div class="col-10">
            <input type="text" class="form-control" [(ngModel)]="merchantDetail.autoClientEmail" name="autoClientEmail">
          </div>
        </div>
        <div class="form-group row">
          <label class="col-2 col-form-label">VPS</label>
          <div class="col-10">
            <input type="text" class="form-control" [(ngModel)]="merchantDetail.vpsName" name="vps">
          </div>
        </div>
        <div class="form-group row">
          <label class="col-2 col-form-label">Bank</label>
          <div class="col-10">
            <input type="text" class="form-control" [(ngModel)]="merchantDetail.bank" name="bank">
          </div>
        </div>
        <div class="form-group row" *ngIf="merchantDetail.merchantType == 2 || merchantDetail.merchantType == 6 || merchantDetail.merchantType == 7">
          <label class="col-2 col-form-label">Access Token</label>
          <div class="col-10">
            <input type="text" class="form-control" [(ngModel)]="merchantDetail.tikTokAccessToken" name="accessToken">
          </div>
        </div>
        <div class="form-group row" *ngIf="merchantDetail.merchantType == 2 || merchantDetail.merchantType == 6 || merchantDetail.merchantType == 7">
          <label class="col-2 col-form-label">Refresh Token</label>
          <div class="col-10">
            <input type="text" class="form-control" [(ngModel)]="merchantDetail.tikTokRefreshToken" name="refreshToken">
          </div>
        </div>
        <div class="form-group row" *ngIf="merchantDetail.merchantType == 2 || merchantDetail.merchantType == 6 || merchantDetail.merchantType == 7">
          <label class="col-2 col-form-label">Cipher Id</label>
          <div class="col-10">
            <input type="text" class="form-control" [(ngModel)]="merchantDetail.tikTokCipherId" name="tikTokCipherId">
          </div>
        </div>
        <div class="form-group row">
          <label class="col-2 col-form-label">Note</label>
          <div class="col-10">
            <textarea type="text" class="form-control" [(ngModel)]="merchantDetail.note" name="note"></textarea>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-2 col-form-label">Auto Sync Message</label>
          <div class="col-10">
            <div class="form-check mt-2">
              <input class="form-check-input" type="checkbox" [(ngModel)]="merchantDetail.autoSyncMessage"
                     name="autoSyncMessage" id="autoSyncMessage">
              <label class="form-check-label" for="autoSyncMessage">Enable auto sync message</label>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-light" (click)="modal.close('Close click')">Cancel</button>
      <button type="button" class="btn btn-primary" (click)="saveMerchant()">Save</button>
    </div>
  </ng-template>

  <ng-template #setupTiktokModal let-modal>
    <div class="modal-header">
      <h4 class="modal-title">Setup Tiktok Api</h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <form name="merchantDetail">
        <div class="form-group row">
          <div class="col-2">Setup Link</div>
          <div class="col-10">
            <input type="text" class="form-control" [(ngModel)]="setupTiktok.setupLink" name="merchantId">
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-light" (click)="modal.close('Close click')">Cancel</button>
      <button type="button" class="btn btn-primary" (click)="setupTiktokApi()">Setup Tiktok Api</button>
    </div>
  </ng-template>
</main>
